
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 115 115","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"58.75","cy":"13.19","r":"9.69","fill":"#483a5b"}}),_c('circle',{staticClass:"st1",attrs:{"cx":"58.75","cy":"105.07","r":"6.43"}}),_c('circle',{attrs:{"transform":"rotate(-73.524 35.787 19.349)","cx":"35.78","cy":"19.35","fill":"#554968","r":"9.21"}}),_c('circle',{staticClass:"st1",attrs:{"cx":"81.72","cy":"98.91","r":"6.11"}}),_c('circle',{attrs:{"transform":"rotate(-36.419 18.97 36.161)","cx":"18.97","cy":"36.16","fill":"#635976","r":"8.75"}}),_c('circle',{attrs:{"transform":"rotate(-60.824 98.536 82.103)","cx":"98.54","cy":"82.1","fill":"#b4b5c7","r":"5.8"}}),_c('circle',{attrs:{"transform":"rotate(-80.921 12.815 59.13)","cx":"12.82","cy":"59.13","fill":"#706883","r":"8.31"}}),_c('circle',{attrs:{"cx":"104.69","cy":"59.13","r":"5.8","fill":"#c1c4d4"}}),_c('circle',{attrs:{"transform":"rotate(-6.148 18.976 82.12)","cx":"18.97","cy":"82.1","fill":"#7e7791","r":"7.9"}}),_c('circle',{attrs:{"transform":"rotate(-37.26 98.543 36.165)","cx":"98.54","cy":"36.16","fill":"#cfd4e2","r":"5.51"}}),_c('circle',{attrs:{"transform":"rotate(-9.769 35.776 98.89)","cx":"35.78","cy":"98.91","fill":"#8b879e","r":"7.5"}}),_c('circle',{attrs:{"transform":"rotate(-80.393 81.721 19.347)","cx":"81.72","cy":"19.35","fill":"#dce3ef","r":"4.98"}})])
          )
        }
      }
    